<template>
  <v-layout>
    <v-container grid-list-md>
      <v-card light id="perf">
        <v-card-text>

            <v-data-table
              :headers="fs_headers"
              :items="wdfs"
              class="elevation-0"
              :hide-actions="true"
            >
              <template v-slot:items="props">
                <td class="text-xs-center">{{ props.item.ward }}</td>
                <td class="text-xs-center">{{props.item.t_bill |toCurrency}}</td>
                <td class="text-xs-center">{{props.item.tot_paid |toCurrency}}</td>
                <td class="text-xs-center">{{props.item.arrears |toCurrency}}</td>
              </template>
            </v-data-table>
            <!-- <v-flex xs12 style="text-align:center">
              <table style="display:block;margin:0 auto;width:60%">
                <tr>
                  <td style="font-weight:bold;text-align:right">Ward:</td>
                  <td style="text-align:left">{{}}</td>
                </tr>
                <tr>
                  <td style="font-weight:bold;text-align:right">Total Fees:</td>
                  <td
                    style="text-align:left"
                  >{{(parseFloat(c_bill)+parseFloat(student_details.fees_arrears))-(calcDiscount(student_details.s_discount,c_bill))|toCurrency}}</td>
                </tr>
                <tr>
                  <td style="font-weight:bold;text-align:right">Paid:</td>
                  <td style="text-align:left">{{tot_paid|toCurrency}}</td>
                </tr>
                <tr>
                  <td style="font-weight:bold;text-align:right">Remaining/Arrears:</td>
                  <td
                    style="text-align:left"
                  >{{|toCurrency}}</td>
                </tr>
              </table>
            </v-flex> -->

        </v-card-text>
      </v-card>
    </v-container>
  </v-layout>
</template>

<script>
export default {
  name: "feeSummary",
  props: {
    student_details: {
      type: Object
    }
  },

  data() {
    return {
      fs_headers: [
        {
          text: "Ward",
          align: "center",
          sortable: false,
          value: "name"
        },
        {
          text: "Total Fees",
          align: "center",
          sortable: false,
          value: "tot_fees"
        },
        {
          text: "Paid",
          align: "center",
          sortable: false,
          value: "paid"
        },
        {
          text: "Remaining/Arrears",
          align: "center",
          sortable: false,
          value: "arrears"
        }
      ]
    };
  },
  computed: {
    tot_paid() {
      let tp = this.student_details.s_payments
        ? this.student_details.s_payments.reduce((sum, val) => {
            return sum + parseFloat(val.amount);
          }, 0)
        : 0;

      return tp;
    },
    c_bill() {
      let bmt = this.student_details.s_class.feestr
        ? parseFloat(this.student_details.s_class.feestr.basic_amt)
        : 0;
      let ac_sum = this.student_details.s_class.feestr
        ? this.student_details.s_class.feestr.adcharges.reduce((sum, val) => {
            return parseFloat(sum) + parseFloat(val.amount);
          }, 0)
        : 0;

      let ttl = bmt + ac_sum;
      return ttl;
    },
    wdfs() {
      return [{
        ward:this.student_details?this.student_details.s_bio.name:'',
        t_bill:this.student_details?(parseFloat(this.c_bill)+parseFloat(this.student_details.fees_arrears))-(this.calcDiscount(this.student_details.s_discount,this.c_bill)):0,
        tot_paid:this.tot_paid,
        arrears:this.student_details?(parseFloat(this.c_bill)+parseFloat(this.student_details.fees_arrears))-(this.calcDiscount(this.student_details.s_discount,this.c_bill)+parseFloat(this.tot_paid)):0
      }]
    }
  },
  methods: {
    calcDiscount(disc, bsum) {
      if (disc) {
        if (disc.val_type == "percentage") {
          return parseFloat(bsum) * (disc.val / 100);
        } else {
          return disc.val;
        }
      } else {
        return 0;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/student/feeSummary.vue